import React from 'react';
import { Form, FieldGroup, FieldLabel, ButtonGroup } from './styles';
import Button from 'src/Components/Common/AdminButton/Button';
import Skeleton from 'react-loading-skeleton';
export default function TicketAlertFormSkeleton() {
    return (React.createElement(Form, null,
        React.createElement(FieldGroup, null,
            React.createElement(FieldLabel, null, "Edificio"),
            React.createElement(Skeleton, { borderRadius: 10, width: "100%", height: 43 })),
        React.createElement(FieldGroup, null,
            React.createElement(FieldLabel, null, "Torre"),
            React.createElement(Skeleton, { borderRadius: 10, width: "100%", height: 43 })),
        React.createElement(FieldGroup, null,
            React.createElement(FieldLabel, null, "Apartamento"),
            React.createElement(Skeleton, { borderRadius: 10, width: "100%", height: 43 })),
        React.createElement(FieldGroup, null,
            React.createElement(FieldLabel, null, "Mensaje"),
            React.createElement(Skeleton, { borderRadius: 10, width: "100%", height: 64 })),
        React.createElement(ButtonGroup, null,
            React.createElement(Button, { disabled: true, className: "white", type: "button" }, "Cancelar"),
            React.createElement(Button, { disabled: true, type: "submit" }, "Guardar"))));
}
